import { FC } from "react";
import { useTranslation } from "react-i18next";
import { FooterLink } from "./types";
import { Link } from "../Link";

export const FooterLinkItem: FC<Omit<FooterLink, "id">> = ({
  href,
  label,
}) => {
  const { t } = useTranslation();

  const title = typeof label === "string" ? label : t(label.i18nKey);

  return (
    <li>
      <Link href={href} className="text-lg text-purple-base font-semibold hover:text-purple-medium !brightness-100">
        {title}
      </Link>
    </li>
  );
};
